import React, { FC } from 'react'
import styled from 'styled-components'
import { Switch, Route, Redirect } from 'react-router'

import { Path } from 'core/Routes'

import Login from './Login'
import Code from './Code'
import Confirm from './Confirm'
import Terms from './Terms'

const AuthContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Auth: FC = () => (
  <AuthContainer>
    <Switch>
      <Route path={Path.LOGIN} component={Login} />
      <Route path={Path.CODE} component={Code} />
      <Route path={Path.CONFIRM} component={Confirm} />
      <Route path={Path.TERMS} component={Terms} />
      <Redirect to={Path.LOGIN} />
    </Switch>
  </AuthContainer>
)

export default Auth
